import "./styles.scss";

export function ProgressBar({
  percent,
  height = 24,
}: {
  percent: number;
  height?: number;
}) {
  const width = `${percent}%`;

  return (
    <div className="progress_bar--container" style={{ height }}>
      <div className="progress" style={{ width, minWidth: height }}></div>
    </div>
  );
}
